import { render, staticRenderFns } from "./drugRemarkModal.vue?vue&type=template&id=53a820b4&scoped=true"
import script from "./drugRemarkModal.vue?vue&type=script&lang=js"
export * from "./drugRemarkModal.vue?vue&type=script&lang=js"
import style0 from "./drugRemarkModal.vue?vue&type=style&index=0&id=53a820b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a820b4",
  null
  
)

export default component.exports